import { Text, Stack, TextInput } from '@mantine/core';
import { formatPhoneNumber, normalizePhoneNumber } from '@bariendo/lib/phone-validations';
import { EditableField, EditableFieldProps, EditableFieldRenderInputProps } from './EditableField';
import { checkFaxValidation } from './services';

export type FaxEditableFieldProps = Omit<EditableFieldProps, 'renderInput' | 'liveValidate' | 'normalizeValue'>;

function FaxInput(props: EditableFieldRenderInputProps) {
  const { value, onChange, onBlur, onKeyDown, disabled, validationError, inputRef, inputProps } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const mergedStyles = {
    ...inputProps?.styles,
    input: {
      ...(inputProps?.styles as any)?.input,
      borderColor: validationError ? 'var(--mantine-color-red-6)' : (inputProps?.styles as any)?.input?.borderColor,
    },
  };

  return (
    <Stack gap={2} style={{ width: '100%' }}>
      <TextInput
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        disabled={disabled}
        ref={inputRef}
        autoFocus
        placeholder="(415) 555-0132"
        {...inputProps}
        styles={mergedStyles}
        error={!!validationError}
      />
      {validationError && (
        <Text size="xs" c="red" style={{ fontSize: '10px' }}>
          {validationError}
        </Text>
      )}
      <Text size="xs" c="dimmed" style={{ fontSize: '10px' }}>
        Include a country code (e.g. +44) for international fax numbers.
      </Text>
    </Stack>
  );
}

export function FaxEditableField(props: FaxEditableFieldProps) {
  return (
    <EditableField
      {...props}
      displayValue={formatPhoneNumber(props.value)}
      liveValidate={checkFaxValidation}
      normalizeValue={normalizePhoneNumber}
      InputComponent={FaxInput}
    />
  );
}
